import React, { Component } from 'react';

// Components
import LegalDocumentLayout from '../LegalDocumentLayout';

// Data
import docData from './data';

class PrivacyPolicy extends Component {
  render() {
    return (
      <LegalDocumentLayout
        docTitle="Privacy Policy"
        docData={docData}
      />
    );
  }
}

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/pages/LegalDocuments/PrivacyPolicy/PrivacyPolicy.js